export default __webpack_public_path__ + "static/media/grid-row-2.163fc627.svg";